import React, { useState } from "react";

import styled from "styled-components/macro";

import API from "Dashboard/API";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";

import FnrButton3 from "UI/FnrButton3";
import { SharedResizing, useSharedResizing } from "UI/SharedResizingArea3";

import Dropdown from "../Dropdown";
import useUpdateSetting from "../useUpdateSetting";

import { Content } from "./DeletionConfirmation";

export default function RemoveStatusInUse({
  status,
  setShow,
  membershipStatusID,
}) {
  return (
    <SharedResizing>
      <Screen1
        key={1}
        status={status}
        setShow={setShow}
        membershipStatusID={membershipStatusID}
      />
      <Screen2
        key={2}
        status={status}
        setShow={setShow}
        membershipStatusID={membershipStatusID}
      />
    </SharedResizing>
  );
}

const Screen1 = ({ status, setShow, membershipStatusID }) => {
  const { updateKey } = useSharedResizing();
  let width = window.innerWidth < 460 ? window.innerWidth : "450px";
  const { updateSetting, error, setError, loading } = useUpdateSetting();

  async function handleDelete() {
    let res = await updateSetting({
      setting: "membershipStatus",
      itemID: membershipStatusID,
      value: null,
      action: "delete",
    });

    if (res) {
      setShow(false);
    }
  }

  return (
    <Wrapper style={{ width: width }}>
      <h3>You are deleting the {status} status.</h3>
      <p>{`There are members with the "${status}" status.`}</p>
      <p>
        Do you want to assign a new status to them or simply remove the status
        from those users?
      </p>

      <ButtonWrapper>
        <FnrButton3 color="red" onClick={handleDelete}>
          <Icon className="far fa-trash-alt" />
          Remove Status
        </FnrButton3>
        <FnrButton3 onClick={() => updateKey(2)} color="green">
          <Icon className="far fa-edit" />
          Assign New Status
        </FnrButton3>
      </ButtonWrapper>
    </Wrapper>
  );
};

const Screen2 = ({ status, setShow, membershipStatusID }) => {
  const { updateKey } = useSharedResizing();
  const { state } = useFamilyRegistrationContext();
  const [selectionId, setSelectionId] = useState();
  const { updateSetting, error, setError, loading } = useUpdateSetting();

  let statuses = state?.familyRegistrationSettings?.membershipStatus?.statuses;

  let width = window.innerWidth < 360 ? window.innerWidth : "350px";

  let options = statuses
    .filter((option) => option.description !== status)
    .map((option) => {
      return {
        id: option.membershipStatusID,
        name: option.description,
      };
    });

  function handleSelect(x) {
    setSelectionId(x);
  }

  async function saveNewStatus() {
    let res = await updateSetting({
      setting: "membershipStatus",
      itemID: membershipStatusID,
      value: selectionId,
      action: "delete",
    });

    if (res) {
      setShow(false);
    }
  }

  return (
    <Wrapper style={{ width: width }}>
      <h3>New Household Status</h3>
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown
          options={options}
          onSelect={handleSelect}
          nameKey="name"
          idKey="id"
          placeholder="Set status"
        />
      </div>

      <ButtonWrapper>
        <FnrButton3 onClick={() => updateKey(1)}>
          <Icon className="far fa-chevron-left" />
          Back
        </FnrButton3>
        <FnrButton3
          color="green"
          onClick={saveNewStatus}
          loading={loading}
          disabled={loading || !selectionId}
        >
          <Icon className="far fa-edit" />
          Assign now
        </FnrButton3>
      </ButtonWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 18px;

  > h3 {
    font-weight: 600;
  }

  > p {
    margin: 0;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
`;

const Icon = styled.i`
  margin-right: 8px;
`;
